import { render, staticRenderFns } from "./panoramaReport.vue?vue&type=template&id=2115388e&"
import script from "./panoramaReport.vue?vue&type=script&lang=js&"
export * from "./panoramaReport.vue?vue&type=script&lang=js&"
import style0 from "./panoramaReport.vue?vue&type=style&index=0&id=2115388e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports